export default __webpack_public_path__ + "static/media/DSC_0514.9e4fb9e9.webp";